import {
  core,
  directToMobile,
  later,
  laterOnboarding,
  mightyOakCardOnboarding,
  spend,
  tiered,
} from './flows/index'
import { Flow, FlowEntry } from './types'

type FlowMap = Record<Flow, FlowEntry[]>

const flowMap: FlowMap = {
  core,
  later,
  laterOnboarding,
  mightyOakCardOnboarding,
  spend,
  tiered,
  directToMobile,
}

export default flowMap
